import { createContext, useContext, useEffect, useState } from "react";
import { api, CUSTOMER_TOKEN_KEY } from "@/lib/api";
import { useConsent } from "@/store/consent";

const Ctx = createContext(null);

export function CustomerProvider({ children }) {
  const { canUseNecessary } = useConsent();
  const [customer, setCustomer] = useState(null);
  const blocked = () => Promise.reject({ response: { data: { detail: "Cookie consent is required to use an account." } } });
  const keep = (data) => { if (data?.token && canUseNecessary) localStorage.setItem(CUSTOMER_TOKEN_KEY, data.token); const { token, ...c } = data; setCustomer(c); return c; };
  const refresh = () => !canUseNecessary ? Promise.resolve(setCustomer(false)) : api.get("/store/auth/me").then(({ data }) => setCustomer(data)).catch((e) => { if (e?.response?.status === 401) localStorage.removeItem(CUSTOMER_TOKEN_KEY); setCustomer(false); });
  useEffect(() => { refresh(); }, [canUseNecessary]);
  const login = async (email, password) => !canUseNecessary ? blocked() : keep((await api.post("/store/auth/login", { email, password })).data);
  const register = async (body) => !canUseNecessary ? blocked() : keep((await api.post("/store/auth/register", body)).data);
  const logout = async () => { if (!canUseNecessary) return setCustomer(false); try { await api.post("/store/auth/logout"); } finally { localStorage.removeItem(CUSTOMER_TOKEN_KEY); setCustomer(false); } };
  return <Ctx.Provider value={{ customer, login, register, logout, refresh, canUseNecessary }}>{children}</Ctx.Provider>;
}

export const useCustomer = () => useContext(Ctx);
